import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgTickSmallAwaiting({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      fill="none"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <circle cx={8} cy={8} r={8} fill="#FB8F23" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.1 4.25a.5.5 0 01.5-.5h6.8a.5.5 0 01.5.5v.3a.5.5 0 01-.5.5h-.685a8.17 8.17 0 01-.016.1c-.171.998-.612 2.185-1.69 2.85 1.078.665 1.519 1.852 1.69 2.85l.016.1h.685a.5.5 0 01.5.5v.3a.5.5 0 01-.5.5H4.6a.5.5 0 01-.5-.5v-.3a.5.5 0 01.5-.5h.685a6.49 6.49 0 01.016-.1c.171-.998.612-2.185 1.69-2.85-1.078-.665-1.519-1.852-1.69-2.85a6.61 6.61 0 01-.016-.1H4.6a.5.5 0 01-.5-.5v-.3zm2.604 1.526a4.296 4.296 0 01-.181-.626h2.954c-.044.208-.103.42-.181.626-.215.566-.54 1.013-1.044 1.274h-.505c-.503-.26-.828-.708-1.043-1.274zm2.592 4.448c.078.206.137.418.181.626H6.523c.044-.208.103-.42.181-.626.215-.566.54-1.013 1.043-1.274h.505c.504.26.83.708 1.044 1.274z"
        fill="#fff"
      />
    </svg>
  );
}

SvgTickSmallAwaiting.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgTickSmallAwaiting.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgTickSmallAwaiting svgRef={ref} {...props} />
));
export default ForwardRef;
